import React, { ReactNode } from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import { Typography } from '@material-ui/core';
import { IProduct } from 'frontend/src/Types/product';
import { useGetFieldList } from './utils/get-field-list';

const useStyles = makeStyles((theme: any) => ({
  formContainer: {
    display: 'flex',
    maxWidth: 448,
    [theme.breakpoints.up('sm')]: {
      display: 'inline-block',
      minWidth: 448,
    },
    justifyContent: 'center',
    border: '2px solid rgba(0, 0, 0, 0.08)',
    boxSizing: 'border-box',
    borderRadius: theme.spacing(1.5),
    flexDirection: 'column',
  },
  childrenContainer: {
    display: 'flex',
    justifyContent: 'center',
    marginBottom: theme.spacing(3),
    marginLeft: theme.spacing(3),
    marginRight: theme.spacing(3),
  },
  displayContainer: {
    display: 'flex',
    justifyContent: 'start',
    margin: theme.spacing(3),
  },
  DisplayDivider: {
    marginTop: theme.spacing(3),
  },
  fieldContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'start',
    alignItems: 'flex-start',
    marginLeft: theme.spacing(3),
    marginRight: theme.spacing(3),
    marginBottom: theme.spacing(2),
  },
  fieldDivider: {
    marginTop: theme.spacing(0.5),
  },
  img: { height: 64, width: 64, borderRadius: theme.spacing(1) },
  itemHeader: {
    fontSize: 20,
    lineHeight: '24px',
    marginLeft: theme.spacing(1.5),
    direction: 'rtl',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
  },
  fieldLabel: {
    fontSize: 12,
    lineHeight: '16px',
  },
  fieldValue: {
    fontSize: 16,
    lineHeight: '24px',
    marginTop: theme.spacing(0.5),
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    maxWidth: 350,
    [theme.breakpoints.down('sm')]: {
      maxWidth: 300,
    },
  },
}));

export default function ProductDetails({
  product,
  step,
  children,
}: {
  product?: IProduct;
  step: number;
  children?: ReactNode;
}) {
  const classes = useStyles();

  const displayFields = useGetFieldList({ step });

  const displayImageAndAsin = product?.image || product?.asin;

  return (
    <div className={classes.formContainer}>
      {displayImageAndAsin ? (
        <div className={classes.displayContainer}>
          <img
            src={product?.image || ''}
            alt="product"
            className={classes.img}
          />
          <Typography paragraph className={classes.itemHeader}>
            {product?.asin || ''}
          </Typography>
        </div>
      ) : (
        <div className={classes.DisplayDivider} />
      )}

      {displayFields.map((field, index) => {
        return (
          <div className={classes.fieldContainer} key={`${field.key}-${index}`}>
            <Typography component="span" className={classes.fieldLabel}>
              {field.label}
            </Typography>
            <Typography paragraph className={classes.fieldValue}>
              {product[field.key] || ''}
            </Typography>
            {index === displayFields.length - 1 && (
              <div className={classes.fieldDivider} />
            )}
          </div>
        );
      })}
      <div className={classes.childrenContainer}>{children}</div>
    </div>
  );
}
